

import johnMaesaka from "../../assets/Pannel Members/john.webp";
import consolatoSergi from "../../assets/Pannel Members/consolato.webp";
import saadTayyab from "../../assets/Pannel Members/saad.webp";
import berndBlobel from "../../assets/Pannel Members/bernd.webp";
import murrayMooYoung from "../../assets/Pannel Members/murray.webp";
import valasiaIakovoglou from "../../assets/Pannel Members/valasia.webp";
import vladlenSlepak from "../../assets/Pannel Members/vladlen.webp";
import yongXiaoWang from "../../assets/Pannel Members/yong.webp";

import johnMaesaka_banner from "../../assets/Pannel Banners/john_banner.webp";
import consolatoSergi_banner from "../../assets/Pannel Banners/consolato_banner.webp";
import saadTayyab_banner from "../../assets/Pannel Banners/saad_banner.webp";
import berndBlobel_banner from "../../assets/Pannel Banners/bernd_banner.webp";
import murrayMooYoung_banner from "../../assets/Pannel Banners/murray_banner.webp";
import valasiaIakovoglou_banner from "../../assets/Pannel Banners/valasia_banner.webp";
import vladlenSlepak_banner from "../../assets/Pannel Banners/vladlen_banner.webp";
import yongXiaoWang_banner from "../../assets/Pannel Banners/yong_banner.webp";

export const panel_members_about = [
  {
    id: "john-maesaka",
    image: johnMaesaka,
    name: "Dr. John K. Maesaka",
    from: "USA",
    about: "NYU Grossman Long Island School of Medicine",
    link: "/executive-panel-members/john-maesaka",
  },
  {
    id: "consolato-sergi",
    image: consolatoSergi,
    name: "Dr. Consolato Sergi",
    from: "Canada",
    about: "University of Alberta and Ottawa",
    link: "/executive-panel-members/consolato-sergi",
  },
  {
    id: "saad-tayyab",
    image: saadTayyab,
    name: "Dr. Saad Tayyab",
    from: "Malaysia",
    about: "UCSI University, Kuala Lumpur",
    link: "/executive-panel-members/saad-tayyab",
  },
  {
    id: "bernd-blobel",
    image: berndBlobel,
    name: "Dr. Bernd Blobel",
    from: "Germany",
    about: "University of Magdeburg",
    link: "/executive-panel-members/bernd-blobel",
  },
  {
    id: "murray-moo-young",
    image: murrayMooYoung,
    name: "Prof. Murray Moo-Young",
    from: "Canada",
    about: "University of Waterloo",
    link: "/executive-panel-members/murray-moo-young",
  },
  {
    id: "valasia-iakovoglou",
    image: valasiaIakovoglou,
    name: "Dr. Valasia Iakovoglou",
    from: "USA",
    about: "Iowa State University",
    link: "/executive-panel-members/valasia-iakovoglou",
  },
  {
    id: "vladlen-slepak",
    image: vladlenSlepak,
    name: "Dr. Vladlen Slepak",
    from: "USA",
    about: "University of Miami Miller School of Medicine",
    link: "/executive-panel-members/vladlen-slepak",
  },
  {
    id: "yong-xiao-wang",
    image: yongXiaoWang,
    name: "Dr. Yong Xiao Wang",
    from: "USA",
    about: "Albany Medical College",
    link: "/executive-panel-members/yong-xiao-wang",
  },
];

export const panel_members = panel_members_about;

export const john_maesaka_data = {
  image: johnMaesaka,
  name: "Dr. John K. Maesaka",
  from: "NYU Grossman Long Island School of Medicine, USA",
  about:
    "John Maesaka, professor of medicine at NYU Grossman Long Island School of Medicine and Chief Emeritus, Division of Nephrology and Hypertension at the NYU Langone Hospital Long Island. He received a BA degree from Harvard University, MD from Boston University School of Medicine, and trained at Barnes Jewish Hospital, Mount Sinai Hospital, and Medical School N.Y. He spent 5 years in a physiology lab at Mount Sinai Medical Center which prepared him for his future research.",
  banner: johnMaesaka_banner,
  link: "/executive-panel-members/john-maesaka",
};

export const consolato_sergi_data = {
  image: consolatoSergi,
  name: "Dr. Consolato Sergi",
  from: "University of Alberta and Ottawa, Canada",
  about:
    "Dr. Sergi is the Chief of the Anatomic Pathology Division at the Children’s Hospital of Eastern Ontario, and Professor of Pediatrics and Pathology at the University of Alberta and Ottawa, Canada. Canadian, born in Rome (Italy), he earned his MD with honors and a Pediatric Pathology Fellowship from the University of Genoa, Italy.",
  banner: consolatoSergi_banner,
  link: "/executive-panel-members/consolato-sergi",
};

export const saad_tayyab_data = {
  image: saadTayyab,
  name: "Dr. Saad Tayyab",
  from: "UCSI University, Kuala Lumpur, Malaysia",
  about:
    "Dr. Saad Tayyab studied Biochemistry at Aligarh Muslim University, India, completing Masters and Ph.D. degrees in 1981 and 1987, respectively. He is currently working as a Professor of Pharmaceutical Chemistry at UCSI University, Kuala Lumpur, Malaysia. Before joining UCSI University, Dr. Saad served at Universiti Malaya (2004-2018), Haramaya University, Ethiopia (2001-2004), Aligarh Muslim University, India (1988-2001), and the University of Kashmir, India (1987-1988). He was admitted as a Fellow, Royal Society of Chemistry, UK, in 2017, Fellow, Royal Society of Biology, UK, in 2019, Member, American Chemical Society in 2020, and Member, Sigma Xi in 2024.  journals.",
  banner: saadTayyab_banner,
  link: "/executive-panel-members/saad-tayyab",
};

export const bernd_blobel_data = {
  image: berndBlobel,
  name: "Dr. Bernd Blobel",
  from: "University of Magdeburg, Germany",
  about:
    "Dr. Bernd Blobel studied Mathematics, Technical Cybernetics and Electronics, Bio-Cybernetics, Physics, Medicine and Informatics at the University of Magdeburg and other universities in the former GDR. He received his PhD in Physics with a neurophysiological study. Furthermore, he performed the Habilitation (qualification as university professor) in Medicine and Informatics.",
  banner: berndBlobel_banner,
  link: "/executive-panel-members/bernd-blobel",
};

export const murray_moo_young_data = {
  image: murrayMooYoung,
  name: "Prof. Murray Moo-Young",
  from: "University of Waterloo, Canada",
  about:
    "Distinguished Professor Emeritus at the University of Waterloo. Educated at London (PhD), Toronto (MSc), and Edinburgh (Postdoc). He’s received awards from ACS, AIMBE, IUPAC, UNESCO, and others for bioengineering research.",
  banner: murrayMooYoung_banner,
  link: "/executive-panel-members/murray-moo-young",
};

export const valasia_iakovoglou_data = {
  image: valasiaIakovoglou,
  name: "Dr. Valasia Iakovoglou",
  from: "Iowa State University, USA",
  about:
    "Dr. Iakovoglou has 25+ years of global experience as an ecophysiologist. Expert in seedling production, biodiversity, climate change. She’s a reviewer/editor of over 25 journals and an IPCC reviewer.",
  banner: valasiaIakovoglou_banner,
  link: "/executive-panel-members/valasia-iakovoglou",
};

export const vladlen_slepak_data = {
  image: vladlenSlepak,
  name: "Dr. Vladlen Slepak",
  from: "University of Miami Miller School of Medicine, USA",
  about:
    "Dr. Slepak studied Biology in Moscow and earned his PhD in Bioorganic Chemistry. He has published 80+ papers on G protein signaling. Professor at University of Miami since 1995.",
  banner: vladlenSlepak_banner,
  link: "/executive-panel-members/vladlen-slepak",
};

export const yong_xiao_wang_data = {
  image: yongXiaoWang,
  name: "Dr. Yong Xiao Wang",
  from: "Albany Medical College, USA",
  about:
    "Full Professor since 2006. Holds MD, PhD, and postdoc training. Funded by NIH, AHA, ADA, and others. Published in Nature, PNAS, Circ Res, etc. Active on journal boards and scientific committees.",
  banner: yongXiaoWang_banner,
  link: "/executive-panel-members/yong-xiao-wang",
};

export const epms_details_map = {
  "john-maesaka": john_maesaka_data,
  "consolato-sergi": consolato_sergi_data,
  "saad-tayyab": saad_tayyab_data,
  "bernd-blobel": bernd_blobel_data,
  "murray-moo-young": murray_moo_young_data,
  "valasia-iakovoglou": valasia_iakovoglou_data,
  "vladlen-slepak": vladlen_slepak_data,
  "yong-xiao-wang": yong_xiao_wang_data,
};
